/* eslint-disable @typescript-eslint/no-deprecated */
export { InfoLabel } from './InfoLabel';
export type { InfoLabelProps, InfoLabelSlots, InfoLabelState } from './InfoLabel.types';
export { renderInfoLabel_unstable } from './renderInfoLabel';
export { useInfoLabel_unstable } from './useInfoLabel';
export { infoLabelClassNames, useInfoLabelStyles_unstable } from './useInfoLabelStyles.styles';
